import {TreeViewBaseItem} from '@mui/x-tree-view';
import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {ExtendedTreeItemProps} from '../../components/eca-doc-list/eca-save-search/EcaSaveSearch';
import {IAnalyzerConfig} from '../../components/indexing/model';

// Define the initial state for the slice

interface IIndexingCustom {
  indexName: string;
  savedSearchId: string;
  savedSearch?: TreeViewBaseItem<ExtendedTreeItemProps> | null;
}
interface IIndexingState {
  indexData: IIndexingDetails;
  addDocsDrawer: boolean;
  confirmModal: boolean;
  showToast: boolean;
  showToastType: string;
  rebuildTrigger: boolean;
  selectedFieldsCount: number;
  addCustomIndex: boolean;
  indexAnalyzers: any;
  selectedMetaField: any;
  indexCustom: IIndexingCustom;
  selectedIndex: string;
  createFieldTemplateId: number;
  indexingList: IIndexingDetails[];
  nlpIndexingSummary: INlpSummaryIndex | null;
  selectedIndexAnalyzer: IAnalyzerConfig | null;
}
export interface IIndexingDetails {
  createdByUser: string;
  totalDocCount: number;
  indexedDocCount: number;
  partialFailedDocCount: number;
  totalFailedDocCount: number;
  status: string;
  date: string;
  type: string;
  name: string;
  record: any;
  ele: any;
}
interface INlpSummaryIndex {
  createdByUser: string;
  date: string;
  indexedDocCount: number;
  partialFailedDocCount: number;
  status: string;
  totalDocCount: number;
  totalFailedDocCount: number;
}
const initialState: IIndexingState = {
  indexData: {
    createdByUser: '',
    totalDocCount: 0,
    indexedDocCount: 0,
    partialFailedDocCount: 0,
    totalFailedDocCount: 0,
    status: '',
    date: '',
    type: '',
    name: '',
    record: '',
    ele: '',
  },
  selectedFieldsCount: 0,
  addDocsDrawer: false,
  confirmModal: false,
  showToast: false,
  showToastType: '',
  rebuildTrigger: false,
  addCustomIndex: false,
  indexAnalyzers: [],
  selectedMetaField: [],
  indexCustom: {
    indexName: '',
    savedSearchId: '',
  },
  selectedIndex: '',
  createFieldTemplateId: 0,
  indexingList: [],
  nlpIndexingSummary: null,
  selectedIndexAnalyzer: null,
};

const IndexingSlice = createSlice({
  name: 'indexing',
  initialState,
  reducers: {
    setIndexingData(state, action: PayloadAction<IIndexingDetails>) {
      state.indexData = action.payload;
    },
    setAddDocsDrawer(state, action: PayloadAction<boolean>) {
      state.addDocsDrawer = action.payload;
    },
    setConfirmModal(state, action: PayloadAction<boolean>) {
      state.confirmModal = action.payload;
    },
    setShowToast(state, action: PayloadAction<boolean>) {
      state.showToast = action.payload;
    },
    setShowToastType(state, action: PayloadAction<string>) {
      state.showToastType = action.payload;
    },
    setSelectedFieldsCount(state, action: PayloadAction<number>) {
      state.selectedFieldsCount = action.payload;
    },
    setRebuildTrigger(state, action: PayloadAction<boolean>) {
      state.rebuildTrigger = action.payload;
    },
    setAddCustomIndex(state, action: PayloadAction<boolean>) {
      state.addCustomIndex = action.payload;
    },
    setIndexAnalyzers(state, action: PayloadAction<any>) {
      state.indexAnalyzers = action.payload;
    },
    setIndexCustom(state, action: PayloadAction<IIndexingCustom>) {
      state.indexCustom = action.payload;
    },
    setSelectedMetaField(state, action: PayloadAction<any>) {
      state.selectedMetaField = action.payload;
    },
    setSelectedIndex(state, action: PayloadAction<string>) {
      state.selectedIndex = action.payload;
    },
    setCreateFieldTemplateId(state, action: PayloadAction<number>) {
      state.createFieldTemplateId = action.payload;
    },
    setIndexingList(state, action: PayloadAction<IIndexingDetails[]>) {
      state.indexingList = action.payload;
    },
    setNlpIndexingSummaryList(state, action: PayloadAction<INlpSummaryIndex>) {
      state.nlpIndexingSummary = action.payload;
    },
    setSelectedIndexAnalyzer(state, action: PayloadAction<IAnalyzerConfig>) {
      state.selectedIndexAnalyzer = action.payload;
    },
    resetCreateCustomIndex(state) {
      state.selectedIndexAnalyzer = initialState.selectedIndexAnalyzer;
      state.selectedMetaField = initialState.selectedMetaField;
      state.indexCustom = initialState.indexCustom;
    },
  },
});

export const {
  setIndexingData,
  setAddDocsDrawer,
  setConfirmModal,
  setShowToast,
  setRebuildTrigger,
  setSelectedFieldsCount,
  setAddCustomIndex,
  setIndexAnalyzers,
  setSelectedMetaField,
  setIndexCustom,
  setSelectedIndex,
  setCreateFieldTemplateId,
  setIndexingList,
  setNlpIndexingSummaryList,
  setShowToastType,
  setSelectedIndexAnalyzer,
  resetCreateCustomIndex,
} = IndexingSlice.actions;

export default IndexingSlice.reducer;
